import AbortService from "@rmp/core/services/abortService";
import { Api } from "@rmp/api-filestorage";
import BaseApiController from "@rmp/core/api/base/baseApiController";

const storageUrl = process.env.VUE_APP_FILE_STORAGE_API_URL!;

export default class BaseStorageController extends BaseApiController<Api<any>> {
	constructor(abortService: AbortService) {
		super(config => new Api<any>(config), storageUrl, abortService);
	}
}
